import Vue from 'vue';
import Vuex from 'vuex';
// import flatpickr from "flatpickr";

Vue.use(Vuex);

var store  = new Vuex.Store({
    modules: {
    },
});

window.axios = require('axios');

Vue.component('dealer-locator', require('./DealerLocator.vue').default);

const app = new Vue({
    el: '#dealer-locator-container',
    store,
});